<template>
  <el-tree-select
    class="tree"
    lazy
    filterable
    remote
    teleported
    clearable
    check-strictly
    :data="orgLists"
    :expand-on-click-node="false"
    :load="load"
    accordion
    :remote-method="searchOrg"
    v-model="scene_code"
    :props="treeSelectProps"
    @node-click="treeSelect"
    @clear="clear"
    :default-expanded-keys="defaultExpandedNodes"
  />
</template>

<script setup>
import { sceneInfoList } from '@/api/common'
import { ref, unref } from 'vue'

const emit = defineEmits(['change'])

const defaultExpandedNodes = ref([])

const scene_code = ref(),
  orgLists = ref([]),
  treeSelectProps = {
    label: 'name',
    children: 'children',
    isLeaf: 'isLeaf',
  }

async function treeSelect(e, node) {
  const data = {
    code: e.code,
    level: e.level,
    defaultExpandedNodes: getParentNodes(node),
  }
  emit('change', data)
}

// 递归获取选中节点以及所有父节点
function getParentNodes(node) {
  let arr = [node.data.value]
  while (node.parent) {
    if(node.parent.data.value) {
      arr.unshift(node.parent.data.value)
    }
    node = node.parent
  }
  return arr
}

async function searchOrg(query) {
  getData(query)
}

async function getData(name) {
  const params = {}
  if (name) {
    params.name = name
  }
  const { result } = await sceneInfoList(params)
  if (result) {
    orgLists.value = result.data.rows.map((item) => ({
      ...item,
      value: item.code,
      isLeaf: false,
      level: result.data.level,
    }))
  }
}

async function load(node, resolve) {
  if (node.isLeaf || node.level === 5) {
    return resolve([])
  }
  const { result } = await sceneInfoList({
    code: node.data.code,
    level: node.level,
  })
  if (result) {
    resolve(
      result.data.rows.map((item) => ({
        ...item,
        value: item.code,
        level: result.data.level,
        isLeaf: node.level === 4 ? true : false,
      }))
    )
  } else {
    resolve([])
  }
}

function clearValue() {
  scene_code.value = undefined
  defaultExpandedNodes.value = []
}

function clear() {
  clearValue()
  emit('change', {})
}

function setValue(value) {
  scene_code.value = value[value.length - 1]
  defaultExpandedNodes.value = value
}

defineExpose({
  setValue,
  clearValue,
})
</script>

<style lang="scss" scoped>
.tree {
  width: 100%;
}
</style>
